import { useWorkspaceMembersList } from '@/shared/api/generated/workspaces/workspaces';
import { unwrap } from '@/shared/api/unwrap';
import { useSession } from '@/shared/auth';
import { usePresence } from '@/shared/realtime';
import { t } from '@/shared/i18n';

import { AvatarStack } from './AvatarStack';

interface Props {
  workspace: string;
  workspaceID: string | undefined;
}

/** В шапке: кто сейчас в пространстве, кроме меня. */
export function OnlineNow({ workspace, workspaceID }: Props) {
  const session = useSession();
  const me = session.status === 'authenticated' ? session.user.id : undefined;
  const online = usePresence(workspaceID === undefined ? undefined : `workspace:${workspaceID}`);
  const members = useWorkspaceMembersList(workspace, {
    query: { select: unwrap, enabled: workspace !== '' },
  });

  return (
    <AvatarStack
      ids={online}
      members={members.data?.members ?? []}
      exclude={me}
      size="xs"
      label={(name) => t.presence.online(name)}
    />
  );
}
